<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper blank-page">
    <!-- Header -->
    <layout-header />
    <!-- /Header -->

    <div class="overflow-hidden bg-light bg-cover bg-no-repeat pb-md-5 pb-4 rounded-none position-relative w-100 features-img"
        :style="'padding-top: 120px;background-position:center;background-image: url('+require('@/assets/img/bg-hero.jpg')+');'">
        <div class="container px-4 py-3 mx-auto position-relative" style="z-index: 1">
          <h2 class="text-center text-white my-5 display-3 fw-bold">Conditions Générales d'Utilisation</h2>
        </div>
    </div>

    <!-- Page Content -->
    <div class="content" style="margin-top: 2rem;">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-xl-9 pb-5">
            <div class="text-center mb-5 mt-4">
              <p class="lead text-muted">
                Bienvenue sur <strong class="text-primary">6v6</strong>, votre plateforme de réservation de terrains de football. 
                Les présentes conditions générales d'utilisation régissent votre accès et votre utilisation de nos services.
              </p>
              <p class="text-muted small">
                <i class="material-icons-outlined align-middle me-1" style="font-size: 18px;">schedule</i>
                Dernière mise à jour : Février 2026
              </p>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">info</i>
                  1. Introduction
                </h5>
                <p class="card-text text-muted">
                  Les présentes CGU régissent l'utilisation de la plateforme <strong>6v6</strong>, permettant la réservation en ligne de terrains de football. En accédant et en utilisant nos services, vous acceptez sans réserve les conditions énoncées ci-dessous.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">login</i>
                  2. Accès aux Services
                </h5>
                <p class="card-text text-muted">
                  L'accès à la plateforme est réservé aux utilisateurs disposant de la capacité juridique pour contracter. L'inscription sur le site est gratuite et nécessite la fourniture d'informations personnelles exactes et à jour.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">checklist</i>
                  3. Utilisation des Services
                </h5>
                <p class="card-text text-muted mb-2">Les utilisateurs s'engagent à :</p>
                <ul class="list-group list-group-flush mb-3">
                  <li class="list-group-item">Utiliser la plateforme conformément à sa destination</li>
                  <li class="list-group-item">Ne pas perturber son bon fonctionnement</li>
                  <li class="list-group-item">Respecter les lois en vigueur</li>
                </ul>
                <div class="alert alert-warning mb-0" role="alert">
                  <i class="material-icons-outlined align-middle me-2">warning</i>
                  Toute utilisation frauduleuse ou abusive des services pourra entraîner la suspension ou la suppression du compte utilisateur.
                </div>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">payment</i>
                  4. Réservation et Paiement
                </h5>
                <p class="card-text text-muted">
                  Les réservations sont effectuées en temps réel et sont confirmées par l'envoi d'un e-mail de confirmation. Le paiement s'effectue par carte bancaire via un système sécurisé.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">cancel</i>
                  5. Politique d'Annulation
                </h5>
                <p class="card-text text-muted">
                  Les conditions d'annulation varient selon les partenaires. En cas d'annulation effectuée avant le délai autorisé, le montant payé sera crédité sous forme de bons d'achat utilisables sur la plateforme. Passé ce délai, aucun remboursement ne sera effectué.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">gavel</i>
                  6. Responsabilités
                </h5>
                <p class="card-text text-muted">
                  La plateforme <strong>6v6</strong> agit en tant qu'intermédiaire entre les utilisateurs et les propriétaires des terrains. Nous ne saurions être tenus responsables des incidents survenant lors de l'utilisation des terrains réservés.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">copyright</i>
                  7. Propriété Intellectuelle
                </h5>
                <p class="card-text text-muted">
                  Tous les contenus présents sur la plateforme, y compris les logos, textes, images et logiciels, sont protégés par des droits de propriété intellectuelle et sont la propriété exclusive de <strong>6v6</strong> ou de ses partenaires.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">update</i>
                  8. Modifications des CGU
                </h5>
                <p class="card-text text-muted">
                  <strong>6v6</strong> se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés de ces modifications par publication sur le site.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">account_balance</i>
                  9. Loi Applicable et Juridiction
                </h5>
                <p class="card-text text-muted">
                  Les présentes CGU sont régies par le droit français. En cas de litige, les tribunaux français seront compétents.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <!-- Footer -->
    <layout-footer />
    <!-- /Footer -->
  </div>
</template>
<script>
export default {
  mounted() {
    // Content div min height set

    function resizeInnerDiv() {
      var height = $(window).height();
      var header_height = $(".header").height();
      var footer_height = $(".footer").height();
      var breadcrumb_height = $(".breadcrumb-bar").height();
      var setheight = height - breadcrumb_height - header_height;
      var trueheight = setheight - footer_height;
      $(".content").css("min-height", trueheight - 30);
    }

    if ($(".content").length > 0) {
      resizeInnerDiv();
    }

    $(window).resize(function () {
      if ($(".content").length > 0) {
        resizeInnerDiv();
      }
    });
  },
};
</script>
